export interface UploadTempDocumentResponseDto {
  fileName: string;
  fileType: string;
  url: string;
}

export const UploadTempDocumentResponseErrorCodes = {
  INVALID_FILE_TYPE: "INVALID_FILE_TYPE",
  INVALID_FILE_SIZE: "INVALID_FILE_SIZE",
};

export type UploadTempDocumentResponseErrorCode =
  (typeof UploadTempDocumentResponseErrorCodes)[keyof typeof UploadTempDocumentResponseErrorCodes];
